// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__AqIbY","title":"Header_title__2MBbz","left":"Header_left__2ahe7","clinicName":"Header_clinicName__pCNWX"};